// pages/PrivacyPolicy.jsx
export default function PrivacyPolicy() {
   return (
    <div className="max-w-3xl mx-auto p-6 font-sans text-primary">
      <h1 className="text-3xl font-heading font-bold mb-4">Privacy Policy</h1>

      <p className="mb-4">
        At ZollowUp, your privacy is our priority. This Privacy Policy describes how we collect, use, and protect your personal information.
      </p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <p>We collect your name, email, phone number, and address during sign up and service bookings.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
      <p>We use your data to manage bookings, communicate updates, and improve our services.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">3. Data Protection</h2>
      <p>Your information is stored securely and not shared with third parties without consent.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">4. Cookies</h2>
      <p>We use cookies to enhance your experience. You can disable them in your browser settings.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">5. Contact Us</h2>
      <p>If you have any questions, contact us at <span className="text-accent">support@zollowup.com</span>.</p>
    </div>
  );
}
